import React, {useState, Fragment, useEffect} from "react";
import PageTitle from "../../layouts/PageTitle";
import {Card, Form, Input, Button, DatePicker, Select, Space, Typography, message, InputNumber} from "antd";
import dayjs from "dayjs";
import {sendEmailService} from "../../../services/EmailService";
import { DeleteOutlined } from '@ant-design/icons';
import "../../../css/email-from.css"
import {useDispatch, useSelector} from "react-redux";
// import {actions as airportsActions} from "../../../store/reducers/AirportsReducer";
import AirportSelect from "./AirportSelect";
import {actions as airportsActions} from "../../../store/reducers/AirportsReducer"; // Adjust the path accordingly
const { TextArea } = Input;
const { Option } = Select;
const { Title } = Typography;


const airlines = [
  "American Airlines",
  "Emirates",
  "Qatar Airways",
  "Turkish Airlines",
  "Lufthansa",
  "Singapore Airlines",
  "Etihad Airways",
  "Delta Air Lines",
  "Royal Jordanian",
  "Egyptair",
  "Saudi Arabian Airlines",
  "Ethiopian Airlines",
  "Other"
];

const cities = ["PIA", "Emirates", "Qatar Airways", "Turkish Airlines"];

const FlightRow = ({ fields, add, remove, section, form }) => (
  <>
    {fields.map(({ key, name, ...restField }) => (
        <Space style={{ display: 'flex', marginBottom: 8 }} align="baseline">
          <Form.Item
            {...restField}
            name={[name, 'airline']}
            rules={[{ required: true, message: 'Missing airline' }]}
          >
            <Select
              placeholder="Airline"
              style={{ width: 170 }}
              onChange={(value) => {
                const current = form.getFieldValue(section === "Depart" ? "departSection" : "returnSection");
                current[name] = { ...current[name], airline: value };
                form.setFieldsValue({
                  [section === "Depart" ? "departSection" : "returnSection"]: current,
                });
              }}
            >
              {airlines.map(a => <Option key={a} value={a}>{a}</Option>)}
            </Select>
          </Form.Item>

          {/* Show text input if "Other" is selected */}
          <Form.Item
            shouldUpdate={(prev, curr) => {
              const prevVal = prev?.[section === "Depart" ? "departSection" : "returnSection"]?.[name]?.airline;
              const currVal = curr?.[section === "Depart" ? "departSection" : "returnSection"]?.[name]?.airline;
              return prevVal !== currVal;
            }}
            noStyle
          >
            {({ getFieldValue }) => {
              const value = getFieldValue(section === "Depart" ? "departSection" : "returnSection")?.[name]?.airline;
              return value === "Other" ? (
                <Form.Item
                  {...restField}
                  name={[name, 'customAirline']}
                  rules={[{ required: true, message: 'Enter airline name' }]}
                >
                  <Input placeholder="Custom Airline" />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>

          <Form.Item {...restField} name={[name, 'from']} rules={[{ required: true, message: 'Missing from' }]}>
            <AirportSelect placeholder="From" />
          </Form.Item>

          <Form.Item {...restField} name={[name, 'to']} rules={[{ required: true, message: 'Missing to' }]}>
            <AirportSelect placeholder="To" />
          </Form.Item>

          <Form.Item {...restField} name={[name, 'fromDate']} rules={[{ required: true, message: 'Missing From Date' }]}>
            <DatePicker showTime placeholder="From Date"  />
          </Form.Item>

          <Form.Item {...restField} name={[name, 'toDate']} rules={[{ required: true, message: 'Missing To Date' }]}>
            <DatePicker showTime placeholder="To Date"  />
          </Form.Item>
          <Button danger onClick={() => remove(name)} icon={<DeleteOutlined />} />
      </Space>
    ))}
    <Form.Item>
      <Button type="dashed" onClick={() => add()} block>
        Add {section} Row
      </Button>
    </Form.Item>
  </>
);



const EmailForm = () => {

  const [form] = Form.useForm();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(airportsActions.onRequest({}));
  }, [dispatch]);

  const onFinish = async (values) => {

    // const payload = {
    //   ...values,
    //   departSection: cleanFlightList(values.departSection),
    //   returnSection: cleanFlightList(values.returnSection),
    // };

    try {
      const response = await sendEmailService(values);
      message.success(response.message || 'Email sent successfully!');
      console.log('Response:', response.data);
    } catch (error) {
      console.error('Error sending email:', error);
      message.error('Failed to send email.');
    }
  };

  return (<>
    <Fragment>
      <PageTitle
        to={"/email-form"}
        activeMenu="SendEmail"
      />

        <Card style={{ maxWidth: 900, margin: 'auto' }}>
          <Title level={3}>Email Sender Form</Title>
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            initialValues={{
              content: `My name is Ali, I’m your personal travel expert. Below you will find information on the itinerary from Chicago to Dubai customized specially for your needs.`,
              grandTotal: 0,
              departDate: dayjs(), // today
              returnDate: dayjs().add(1, 'day'), // tomorrow
            }}
          >
            <Form.Item
              label="Customer Name"
              name="customerName"
              rules={[
                { required: true, message: "Customer name is required" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Customer Email"
              name="customerEmail"
              rules={[
                { required: true, message: "Customer email is required" },
                { type: "email", message: "Invalid email format" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Email Subject"
              name="subject"
              rules={[
                { required: false }
              ]}
            >
              <Input placeholder="Enter email subject" />
            </Form.Item>
            <Form.Item
              label="Email Content"
              name="content"
              rules={[
                { required: true }
              ]}
            >
              <TextArea rows={4} />
            </Form.Item>
            <Form.Item
              label="Grand Total"
              name="grandTotal"
              rules={[
                { required: false }
              ]}
            >
              <InputNumber placeholder="Enter grand total" style={{width: "100%"}}/>
            </Form.Item>
            <Form.Item
              label="Depart Date"
              name="departDate"
              rules={[
                { required: true }
              ]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
            <Form.List
              name="departSection"
              // rules={[
              //   {
              //     validator: async (_, names) => {
              //       if (!names || names.length < 1) {
              //         return Promise.reject(new Error("At least one depart flight is required"));
              //       }
              //     },
              //   },
              // ]}
            >
              {(fields, { add, remove }) => (
                <FlightRow fields={fields} add={add} remove={remove} form={form} section="Depart" />
              )}
            </Form.List>

            <Form.Item
              label="Return Date"
              name="returnDate"
              rules={[
                { required: true }
              ]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
            <Form.List
              name="returnSection"
              // rules={[
              //   {
              //     validator: async (_, names) => {
              //       if (!names || names.length < 1) {
              //         return Promise.reject(new Error("At least one return flight is required"));
              //       }
              //     },
              //   },
              // ]}
            >
              {(fields, { add, remove }) => (
                <FlightRow fields={fields} add={add} remove={remove} form={form} section="Return" />
              )}
            </Form.List>

            <Form.Item>
              <Button type="primary" htmlType="submit" block>Submit</Button>
            </Form.Item>
          </Form>
        </Card>

    </Fragment>
  </>);
}

export default EmailForm;